<template>
  <v-row class="ma-0 mt-3">
    <v-col
      v-for="col in itemsInRange"
      :key="col"
      :style="getBackgroundColor(col - 1)"
      :class="['range-selection', selectedValue === col - 1 ? 'active' : '']"
      @click="setAsActive(col)"
    >
      <div class="number">
        {{ col - 1 }}
      </div>
      <div class="my-4">
        <div
          class="arrow-down"
          :style="getArrowColor(col - 1)"
          v-if="col - 1 === 0 || col - 1 === itemsInRange - 1"
        ></div>
        <div v-if="col - 1 === 0">None</div>
        <div v-if="col - 1 === itemsInRange - 1">
          Worst <br />
          imaginable
        </div>
      </div>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'GradientRange',
  props: {
    value: Number,
    cols: Number,
    color: String,
  },
  data() {
    return {
      selectedValue: this.value,
    }
  },
  computed: {
    itemsInRange() {
      return this.cols
    },
    gradientColor() {
      if (this.color.includes('#')) return this.color
      return '#' + this.color
    },
  },
  methods: {
    getBackgroundColor(value) {
      const step = 255 / (this.itemsInRange - 1)
      let index = Math.ceil(step * value)
      if (index > 255) index = 255
      let opacity = index.toString(16)
      if (opacity.length === 1) opacity = '0' + opacity
      return 'background:' + this.gradientColor + opacity
    },
    getArrowColor(value) {
      if (value === 0) return 'border-top-color: #add8e6a6'
      const step = 255 / (this.itemsInRange - 1)
      let index = Math.ceil(step * value)
      if (index > 255) index = 255
      let opacity = index.toString(16)
      if (opacity.length === 1) opacity = '0' + opacity
      return 'border-top-color:' + this.gradientColor + opacity
    },
    setAsActive(value) {
      this.selectedValue = value - 1
      this.$emit('input', this.selectedValue)
    },
  },
}
</script>

<style scoped>
.range-selection {
  padding: 0;
  height: 224px;
}

.range-selection.active {
  border: 4px solid white;
  box-shadow: 0 0 8px 2px #6e6e6e99;
}

.range-selection .number {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 20px solid;
}

.reference {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
}
</style>
